var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseModal',{attrs:{"title":_vm.$t('Attached files')}},[_c('FilesTable',{attrs:{"files":_vm.context.files}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }